import { ref, onMounted, onUnmounted } from 'vue';

export function useThemeColors() {
  const isDark = ref(false);

  const updateTheme = () => {
    isDark.value = document.body.classList.contains('dark');
  };

  let observer;

  onMounted(() => {
    updateTheme();

    observer = new MutationObserver(() => {
      updateTheme();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });

  onUnmounted(() => {
    if (observer) {
      observer.disconnect();
    }
  });

  const getChartColors = () => {
    return {
      textPrimary: isDark.value ? '#f1f5f9' : '#0f172a',
      textSecondary: isDark.value ? '#cbd5e1' : '#334155',
      textMuted: isDark.value ? '#94a3b8' : '#64748b',

      background: isDark.value ? '#1e293b' : '#ffffff',
      backgroundAlt: isDark.value ? '#334155' : '#f8fafc',

      border: isDark.value ? '#475569' : '#e2e8f0',
      borderLight: isDark.value ? '#64748b' : '#cbd5e1',

      gridColor: isDark.value ? '#475569' : '#e2e8f0',
      tooltipBg: isDark.value
        ? 'rgba(30, 41, 59, 0.95)'
        : 'rgba(255, 255, 255, 0.95)',
      tooltipBorder: isDark.value ? '#64748b' : '#cbd5e1',

      chartPalette: ['#0062B1', '#1C7CFC', '#0693E3', '#009CE0', '#2CCCE4'],
    };
  };

  return {
    isDark,
    getChartColors,
  };
}
